/*
 * Module for the statements Index view
*/
rs.module("content/communications/statements/index",

    [],

    function () {
        //
        // Initialize
        //
        function initialize(jsSelectors, listApi) {

            listApi.onItemDeleted(function () {

                // Disclaimer is hidden on mobile 
                if (!$.isMobile()) {
                    var noCorrespondence = listApi.items().length == 0;
                    $.js(jsSelectors.disclaimer).toggle(!noCorrespondence);
                }
            });

            // When a correspondence is downloaded, remove its new indicators (there are 2, one for mobile and one for desktop)
            listApi.onItemDownloadCompleted(function (item, context) {
                $(item).js(jsSelectors.newIndicator, { required: false, multiple: true }).remove();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);